module.exports = __webpack_public_path__ + "img/maritzburg-united.21969b45.png";